import styled from '@emotion/styled'
import { WidgetContent, TopBarSection, TextField, Select } from '@duik/it'
import DatePicker from 'react-datepicker'
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded'
import ExpandLessIcon from '@material-ui/icons/ExpandLessRounded'

export const StyledDatePicker = styled(DatePicker)`
  border: 1px solid #eaedf3 !important;
`

export const ReportDetailContainer = styled.div`
  margin: 32px;
`

export const TopContainer = styled.div`
  width: 100%;
`

export const TopContainerText = styled.h2`
  padding-left: 25px;
  width: fit-content;
`

export const TopWrapper = styled(WidgetContent)`
  padding: 8px 0;
`

export const ReportDetailInfoContainer = styled.div`
  display: flex;
  margin-bottom: 6px;
`

export const ReportDetailInfoText = styled.p`
  width: 100px;
  color: #6b6c70;
`

export const GreyText = styled.p`
  color: #3e3f42;
`

export const MainReportContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const MainReportDetailContainer = styled.div`
  width: 330px;
`

export const MainReportDetail = styled.div`
  height: 56px;
  background-color: #023059;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
`

export const MainReportDetailText = styled.p`
  margin-left: 34px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
`

export const MainReportDetails = styled.div`
  height: 88px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color-base);
`

export const MainReportDetailsText = styled.p`
  margin-left: 34px;
  font-size: 54px;
  color: #1f2229;
`

export const ReportDetailInfoWrapper = styled.div`
  border-bottom: 1px solid var(--border-color-base);
`

export const ExpandableLineContainer = styled.div`
  margin: 32px 100px;
`

export const StyledExpandLessIcon = styled(ExpandLessIcon)`
  margin-left: 12px;
  margin-right: 12px;
`
export const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  margin-left: 12px;
  margin-right: 12px;
`

export const DriverContainer = styled.div`
  padding-left: 20px;
`

export const DriverText = styled.p`
  display: flex;
`

export const ExpandableLineWrapper = styled.div`
  margin: 8px 100px;
`

export const StyledTopBar = styled(TopBarSection)`
  padding: 0 30px;
`

export const ReportNumText = styled.p`
  font-size: 0.875rem;
  color: #9ea0a5;
  padding: 0 15px;
`
